import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { AppConfigContext } from '@providers/AppConfigProvider';

export default function MainLogoWhite() {
  const { pathRoot } = useContext(AppConfigContext);
  return (
    <Box className="m-0 p-0">
      <Link href="/" className="m-0 p-0 inline-block">
        <img
          src={`${pathRoot}/assets/images/common/logo_white.svg`}
          alt="logoWhite"
          className="h-10 max-md:w-[132px] max-md:h-[30px]"
        />
      </Link>
    </Box>
  );
}
